/* tslint:disable */
/* eslint-disable */
/**
 * Finastic Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CountryCode = {
    Invalid: 'Invalid',
    Ro: 'RO',
    Pl: 'PL'
} as const;
export type CountryCode = typeof CountryCode[keyof typeof CountryCode];


export function CountryCodeFromJSON(json: any): CountryCode {
    return CountryCodeFromJSONTyped(json, false);
}

export function CountryCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountryCode {
    return json as CountryCode;
}

export function CountryCodeToJSON(value?: CountryCode | null): any {
    return value as any;
}

